var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticStyle:{"min-width":"60px"},attrs:{"id":_vm.id,"type":"number","pattern":_vm.decimal ? '[-+]?[0-9]*[.,]?[0-9]+' : '[0-9.]*'},domProps:{"value":_vm.text},on:{"change":_vm.change,"input":function($event){return _vm.$emit('input', $event.target.value)},"keypress":function($event){return _vm.isNumber($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }